import React from 'react';
import DashboardDropdown from '../DashboardDropdown';
import WidgetHeader from '../WidgetHeader';
import Button from '@material-ui/core/Button';
import CogIcon from 'components/pure/utils/icon/CogIcon';
import Dialog from 'components/pure/utils/Dialog';
import CallColorsConfig from 'components/manager-dashboard/conversation-timeline/CallColorsConfig';

export default class ConversationTimelineHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      callColorsOpen: false,
      tempColorList: null,
      disableSave: true,
    };

    this.openCallColors = this.openCallColors.bind(this);
    this.closeCallColors = this.closeCallColors.bind(this);
    this.saveCallColors = this.saveCallColors.bind(this);
    this.colorListUpdated = this.colorListUpdated.bind(this);
  }

  openCallColors() {
    this.setState({
      callColorsOpen: true,
      tempColorList: this.props.colorList,
    });
  }

  closeCallColors() {
    this.setState({
      callColorsOpen: false,
    });
  }

  saveCallColors() {
    if (this.colorListIsValid()) {
      this.setState({
        callColorsOpen: false,
      });
      this.props.colorListUpdated(this.state.tempColorList);
    }
  }

  colorListUpdated(colorList) {
    this.setState({
      ...this.state,
      tempColorList: colorList,
    });
  }

  colorListIsValid() {
    return (
      this.state.tempColorList !== null &&
      this.state.tempColorList.filter(item => item.value === null).size === 0
    );
  }

  render() {
    const {
      selectedPeriod,
      timeframeOptions,
      selectedSearchFieldId,
      searchFieldSelect,
      searchFieldOptions,
    } = this.props;

    const disableSave = !this.colorListIsValid();

    return (
      <WidgetHeader title={selectedPeriod.text + "'s Conversations"}>
        {searchFieldSelect.length > 0 && (
          <Button variant="outlined" className="stage-colors" onClick={this.openCallColors}>
            <CogIcon />
            Colors
          </Button>
        )}
        {this.state.callColorsOpen && (
          <Dialog
            title="Call Color Configuration"
            className="call-color-dialog"
            closeButton={true}
            actions={[
              <Button
                variant="contained"
                color="primary"
                className="ev-button"
                onClick={this.saveCallColors}
                disabled={disableSave}>
                Save
              </Button>,
              <Button variant="outlined" className="ev-button" onClick={this.closeCallColors}>
                Cancel
              </Button>,
            ]}
            modal={true}
            open={true}
            onRequestClose={this.closeCallColors}
            autoScrollBodyContent={true}>
            <CallColorsConfig
              searchFieldSelect={searchFieldSelect}
              selectedSearchFieldId={selectedSearchFieldId}
              searchFieldChanged={this.props.searchFieldChanged}
              searchFieldOptions={searchFieldOptions}
              colorList={this.state.tempColorList}
              colorListUpdated={this.colorListUpdated}
            />
          </Dialog>
        )}
        <DashboardDropdown
          selectedItem={selectedPeriod}
          selectionOptions={timeframeOptions}
          updateSelection={this.props.updatePeriod}
          textProperty="text"
          keyProperty="key"
        />
      </WidgetHeader>
    );
  }
}
